import React from 'react'

import { Card } from '@it-incubator/ui-kit'

import style from './Result.module.css'

import { CircleResult } from 'common/components'

type PropsType = {
  rightAnswersQuantity: number
  answersQuantity: number
  resultPercent: number
}

export const Result = ({ rightAnswersQuantity, answersQuantity, resultPercent }: PropsType) => {
  return (
    <Card className={style.card} contentClassName={style.box}>
      <CircleResult value={resultPercent} />
      <div>
        <h2 className={style.title}>Ваш результат теста</h2>
        <p className={style.text}>
          Вы ответили верно на&nbsp;{rightAnswersQuantity} из {answersQuantity} вопросов
        </p>
      </div>
    </Card>
  )
}
